export default [
  {
    title: 'Con/Apt Pin',
    icon: 'MapPinIcon',

    tagVariant: 'light-warning',
    resource: 'Place',
    action: 'read',
    children: [
      {
        title: 'Lists',
        route: 'place-lists',
        resource: 'Place',
        action: 'read',
      },
      {
        title: 'Add',
        route: 'pin-create',
        resource: 'Place',
        action: 'create',
      },
      {
        // ตรวจว่ามี place ไหนยังไม่ถูกผูกโซน (ค้นหาตามโซนจะหาไม่เจอ)
        title: 'ยังไม่มีโซน',
        route: 'place-without-zone',
        resource: 'Place',
        action: 'read',
      },
      {
        // ไล่ตรวจพิกัดทีละรายการ: นอกไทย / ซ้ำกับที่อื่น / หลุดโซนที่ผูกไว้
        title: 'ตรวจพิกัด',
        route: 'place-coordinate-audit',
        resource: 'Place',
        action: 'read',
      },
      {
        // ตรวจพิกัดที่แนะนำจาก google_data ก่อนนำไปใช้จริง
        title: 'ตรวจพิกัดที่แนะนำ',
        route: 'place-coord-review',
        resource: 'Place',
        action: 'read',
      },
      {
        // ไล่ดู condo/apt ที่ซ้ำกัน จากไฟล์ place_lang - for_import.csv
        title: 'Property Duplicate',
        route: 'property-duplicate',
        resource: 'Property',
        action: 'read',
      },

    ],
  },
]
